// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import InfoImg from "./../../../Assets/Images/CommanImages/Informative.png";
// import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
// import FlagIcon from "./../../../Assets/Images/CommanImages/flag_icon.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { API_BASE_URL } from "../../../Config/Config";
// import "../QuestionDashboard/questiondashborad.css";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";
// import "./quesbank.css";
// import TablewithCheckbox from "../../../Components/TableComponent/TablewithCheckbox";
// import EndPoints from "../../../Api/Endpoints";


// const TableComponent = ({
//   headers,
//   data,
//   searchPlaceholder,
//   dataClient,
//   setPagePath,
//   renderQuestionText,
//   selectedRows,
//   setSelectedRows,
//   renderQuestionTextModel,
//   toggleImage,
//   expandedStates,
//   questionDetailsMap,
//   handleEyeClick,
//   isLoading = false,
// }) => {
//   const navigate = useNavigate();
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10); 
//   const [totalCount, setTotalCount] = useState(0);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const isAllSelected = selectedRows.length === data.length;
//   const columnDropdownRef = useRef(null);
//   const flagCountIndex = headers.indexOf("Flag Count");
//   const statusTextIndex = headers.indexOf("Status");
//   const [filters, setFilters] = useState({}); // Holds current selections
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   const [isFilterDropdownSelected, setIsFilterDropdownSelected] =
//     useState(false);
//   const [selectedQuestion, setSelectedQuestion] = useState(null);
//   const [isQuesModalVisible, setIsQuesModalVisible] = useState(false);
//   const [changeStatus, setChangeStatus] = useState(false);
//   useEffect(() => {
//     if (headers.length > 0) {
//       const initial = headers
//         .filter((header) => header !== "Status" && header !== "Set ID")
//         .slice(0, 5); // First 5 visible columns
//       setVisibleColumns([
//         headers[0],
//         ...initial.filter((h) => h !== headers[0]),
//       ]);
//     }
//   }, [headers]);

//   const handleColumnSelection = (column) => {
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter((col) => col !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); // Persist selected filters
//       setCurrentPage(1); // Reset to the first page
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const handleFilterSelection = (selectedOption, header) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [header]: selectedOption,
//     }));

//     setIsFilterDropdownSelected(true); // Mark dropdown as interacted
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         if (a[colIndex] < b[colIndex]) {
//           return sortConfig.direction === "asc" ? -1 : 1;
//         }
//         if (a[colIndex] > b[colIndex]) {
//           return sortConfig.direction === "asc" ? 1 : -1;
//         }
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handleExport = (type) => {
//     const exportData = sortedData.map((row) =>
//       visibleColumns.map((column) => row[headers.indexOf(column)])
//     );

//     const fileName = prompt("Enter the file name:");

//     if (!fileName) {
//       return;
//     }

//     if (type === "excel" || type === "csv") {
//       const worksheet = XLSX.utils.aoa_to_sheet([
//         visibleColumns,
//         ...exportData,
//       ]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//       const fileExtension = type === "csv" ? "csv" : "xlsx";
//       const mimeType =
//         type === "csv"
//           ? "text/csv"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

//       const file = XLSX.write(workbook, {
//         bookType: fileExtension,
//         type: "array",
//       });
//       const blob = new Blob([file], { type: mimeType });
//       FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({
//         head: [visibleColumns],
//         body: exportData,
//       });

//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {i}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };

//   const handleSelectAll = (e) => {
//     if (e.target.checked) {
//       if (Object.keys(appliedFilters).length > 0) {
//         // If filters are applied, select only filtered data
//         const filteredIds = paginatedData.map((row) => row[0]);
//         setSelectedRows((prevSelected) => {
//           // Combine previously selected rows with new filtered selections
//           const combined = [...prevSelected, ...filteredIds];
//           // Remove duplicates
//           return [...new Set(combined)];
//         });
//       } else {
//         // If no filters, select all data
//         setSelectedRows(data.map((row) => row[0]));
//       }
//     } else {
//       if (Object.keys(appliedFilters).length > 0) {
//         // If filters are applied, deselect only filtered data
//         const filteredIds = paginatedData.map((row) => row[0]);
//         setSelectedRows((prevSelected) =>
//           prevSelected.filter((id) => !filteredIds.includes(id))
//         );
//       } else {
//         // If no filters, deselect all
//         setSelectedRows([]);
//       }
//     }
//   };
//   // const handleSelectAll = (e) => {
//   //   if (e.target.checked) {
//   //     setSelectedRows(data.map((row) => row[0])); // Assuming the first column contains the question ID
//   //   } else {
//   //     setSelectedRows([]);
//   //   }
//   // };

//   const handleRowSelect = (rowIndex) => {
//     const questionId = paginatedData[rowIndex][0];
//     setSelectedRows((prev) => {
//       if (prev.includes(questionId)) {
//         return prev.filter((id) => id !== questionId);
//       } else {
//         return [...prev, questionId];
//       }
//     });
//   };
//   // const handleRowSelect = (rowIndex) => {
//   //   const questionId = data[rowIndex][0]; // Assuming the first column contains the question ID
//   //   if (selectedRows.includes(questionId)) {
//   //     setSelectedRows(selectedRows.filter((id) => id !== questionId));
//   //   } else {
//   //     setSelectedRows([...selectedRows, questionId]);
//   //   }
//   // };

//   const [columnWidth, setColumnWidth] = useState(400); // Default width for first column
//   const columnRef = useRef(null);
//   const isResizing = useRef(false);

//   const handleMouseDown = (event) => {
//     isResizing.current = true;
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (event) => {
//     if (isResizing.current) {
//       const newWidth = Math.max(
//         100,
//         event.clientX - columnRef.current.offsetLeft
//       ); // Min width: 100px
//       setColumnWidth(newWidth);
//     }
//   };

//   const handleMouseUp = () => {
//     isResizing.current = false;
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//   };

//   const toggleChangeStatusVisibility = () => {
//     setChangeStatus((prevState) => !prevState);
//   };

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "1.5%",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "82vw",
//           }}
//         >
//           {/* <div style={{ display: "flex", alignItems: "center" }}>
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="input-top-tc"
//               onChange={handleSearch}
//             />
//             <img src={searchicon} className="search-icon-tc" alt="search" />
//           </div> */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img
//               src={searchicon}
//               alt="search"
//               className="search-icon-ques-dash"
//             />
//           </div>
//           <div
//             style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
//           >
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
//             {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration:
//                     size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img
//             src={Filter}
//             style={{ height: "24px", width: "24px" }}
//             alt="filter"
//           />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           // className="col-tc"
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {headers
//                   .filter(
//                     (header) => header !== "Set ID" && header !== "Status"
//                   )
//                   .map((column, index) => (
//                     <div
//                       key={index}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleColumnSelection(column);
//                       }}
//                     >
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         name="columnSelection"
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         readOnly
//                         disabled={column === "Question ID"}
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {/* {data.length > 0 ? ( */}
//       {isLoading ? (
//         <div style={{ 
//           display: 'flex', 
//           justifyContent: 'center', 
//           alignItems: 'center', 
//           minHeight: '400px',
//           flexDirection: 'column',
//           gap: '20px'
//         }}>
//           <div className="loader-tc"></div>
//           <span style={{ color: '#6A6A6A', fontSize: '16px' }}>
//             Loading questions, please wait...
//           </span>
//         </div>
//       ) : data.length > 0 ? (
//         <>
//           <div className="table-wrapper-cols-selections">
//             <table className="table-tc" style={{ width: "100%" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <td
//                       key={index}
//                       ref={index === 1 ? columnRef : null}
//                       className={`Heading-tc resizable-header ${
//                         index === 1 ? "resizable-header" : ""
//                       }`}
//                       style={{
//                         textAlign: "right",
//                         cursor: "pointer",
//                         width: index === 1 ? `${columnWidth}px` : "auto",
//                         position: "relative", // Ensure position for pseudo-element
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "left",
//                           justifyContent: "left",
//                         }}
//                       >
//                         {index === 0 && (
//                           <input
//                             type="checkbox"
//                             className="delete-question-checkbox-dqc"
//                             checked={isAllSelected}
//                             onChange={handleSelectAll}
//                             style={{
//                               width: "20px",
//                               height: "20px",
//                               marginRight: "105px",
//                             }}
//                           />
//                         )}
//                         {heading}
//                         {index === 1 && (
//                           <div
//                             className="resize-handle"
//                             onMouseDown={handleMouseDown}
//                           ></div>
//                         )}
//                         <img
//                           onClick={() => handleSort(heading)}
//                           src={updown}
//                           style={{
//                             height: "20px",
//                             width: "20px",
//                             marginLeft: "5px",
//                           }}
//                           alt="sort"
//                         />
//                       </span>
//                     </td>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedData.map((row, rowIndex) => (
//                   <tr
//                     key={rowIndex}
//                     className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
//                   >
//                     {visibleColumns.map((column, cellIndex) => (
//                       <td
//                         key={cellIndex}
//                         style={{
//                           width: cellIndex === 1 ? `${columnWidth}px` : "auto",
//                           textAlign: "left",
//                           color: "#6A6A6A",
//                           verticalAlign: "middle",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           maxWidth: `${columnWidth}px`,
//                           width: "200px",
//                         }}
//                       >
//                         {cellIndex === 0 ? ( // Ensure link only appears once
//                           <div
//                             style={{ display: "flex", alignItems: "center" }}
//                           >
//                             <input
//                               type="checkbox"
//                               className="delete-question-checkbox-dqc"
//                               checked={selectedRows.includes(row[0])}
//                               onChange={() => handleRowSelect(rowIndex)}
//                             />
//                             <div
//                               style={{
//                                 width: "100px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "space-between",
//                               }}
//                             >
//                               {/* <div className="flag-container-ques-bank-dash">
//                                 {row[7] > 0 && (
//                                   <div className="flag-count-ques-bank-dash">
//                                     <span>{row[7] > 99 ? "99" : row[7]}</span>
//                                   </div>
//                                 )}
//                                 {row[7] > 0 && (
//                                   <img
//                                     src={FlagIcon}
//                                     alt="flag count"
//                                     style={{ width: "24px" }}
//                                   />
//                                 )}
//                               </div> */}
//                               <div className="flag-container-ques-bank-dash">
//                                 {row[flagCountIndex] > 0 && (
//                                   <>
//                                     <div className="flag-count-ques-bank-dash">
//                                       <span>
//                                         {row[flagCountIndex] > 99
//                                           ? "99"
//                                           : row[flagCountIndex]}
//                                       </span>
//                                     </div>
//                                     <img
//                                       src={FlagIcon}
//                                       alt="flag"
//                                       style={{ width: "24px" }}
//                                     />
//                                   </>
//                                 )}
//                               </div>

//                               {/* <div> */}
//                               <span
//                                 style={{
//                                   width: "20px",
//                                   textAlign: "center",
//                                   marginRight: "40px",
//                                 }}
//                               >
//                                 {row[statusTextIndex] === "Marked special" && (
//                                   <span
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() => handleEyeClick(row[0])}
//                                   >
//                                     <img
//                                       src={EyeLockIcon}
//                                       alt="eyeicon"
//                                       style={{ width: "20px", height: "20px" }}
//                                     />
//                                   </span>
//                                 )}
//                               </span>
//                             </div>
//                             <Link
//                               style={{ color: "#337ab7" }}
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 const questionId = row[0]; // Assuming first column contains Question ID
//                                 setSelectedQuestion(
//                                   questionDetailsMap[questionId]
//                                 ); // Retrieve from stored data
//                                 setIsQuesModalVisible(true); // Show modal
//                               }}
//                             >
//                               <span
//                                 className="truncated-text"
//                                 title={row[headers.indexOf(column)]}
//                               >
//                                 {headers.indexOf(column) === 2
//                                   ? renderQuestionText(
//                                       row[headers.indexOf(column)]
//                                     ) // Render LaTeX here
//                                   : row[headers.indexOf(column)]}
//                               </span>
//                             </Link>
//                           </div>
//                         ) : (
//                           <span className="truncated-text-2">
//                             {headers.indexOf(column) === 2
//                               ? renderQuestionText(row[headers.indexOf(column)]) // Render LaTeX for LaTeX column
//                               : row[headers.indexOf(column)]}
//                           </span>
//                         )}
//                       </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="pagination-tc">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//               className="extreme-left-tc-pagination"
//             >
//               <img src={leftArrow} alt="" />
//             </button>
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="lefttc-pagination"
//             >
//               {"<"}
//             </button>
//             {renderPagination()}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="righttc-pagination"
//             >
//               {">"}
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//               className="extreme-right-tc-pagination"
//             >
//               <img src={rightArrow} alt="" />
//             </button>
//           </div>
//         </>
//       ) : (
//       <div style={{ textAlign: 'center', padding: '40px', color: '#6A6A6A', fontSize: '16px' }} >
//         No data available
//       </div>
//     )}
//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button
//               className="repman-cross-btn-HOD"
//               onClick={() => {
//                 setIsFilterVisible(false);
//               }}
//             >
//               <p>X</p>
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               {/* Show the Reset button only after Apply is clicked */}

//               {/* Always show the Apply button */}
//               <button
//                 className="create-test-section-btn"
//                 onClick={handleApplyFilter}
//               >
//                 APPLY
//               </button>
//               {isFiltersApplied && (
//                 <button
//                   className="create-test-section-btn"
//                   onClick={handleResetFilter}
//                 >
//                   RESET
//                 </button>
//               )}
//             </div>
//             <div
//               className="filter-options-container"
//               style={{
//                 maxHeight: "550px", // Set a maximum height for the container
//                 overflowY: "auto", // Enable vertical scrolling
//                 paddingRight: "10px", // Add padding for better UX
//               }}
//             >
//               {/* {headers.slice(3).map((header, index) => {
//                 const uniqueOptions = [
//                   ...new Set(
//                     data.map((row) => row[index + 3]).filter((option) => option)
//                   ),
//                 ]; */}
//               {/* {headers
//                 .filter((_, index) => index === 0 || (index >= 3 && index !== 4)) // Skip indexes 2 and 4
//                 .map((header, filteredIndex) => {
//                   const originalIndex =
//                     filteredIndex === 0 ? 0 : filteredIndex + 2 + (filteredIndex >= 2 ? 1 : 0); // Adjust for skipped indexes 2 and 4

//                   const uniqueOptions = [
//                     ...new Set(
//                       data
//                         .map((row) => row[originalIndex])
//                         .filter((option) => option)
//                     ),
//                   ]; */}
//               {headers
//                 .filter(
//                   (header) =>
//                     // header !== "Question ID" &&
//                     header !== "Question Text"
//                 )
//                 .map((header) => {
//                   const actualIndex = headers.indexOf(header); // ✅ Get original index directly

//                   const uniqueOptions = [
//                     ...new Set(
//                       data.map((row) => row[actualIndex]).filter(Boolean)
//                     ),
//                   ];

//                   return (
//                     <SelectedValuesDropdown
//                       key={actualIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption,
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}
//             </div>
//           </div>
//         </div>
//       )}
//       {/* {isQuesModalVisible && selectedQuestion && (
//         <div
//           className="modal-overlay"
//           onClick={() => setIsQuesModalVisible(false)}
//         >
//           <div className="modal-content-all-question">
//             <button
//               className="modal-close-button"
//               onClick={() => setIsQuesModalVisible(false)}
//             >
//               X
//             </button>

//             <div className="modal-header-del">
//               <p
//                 style={{
//                   fontSize: "18px",
//                   backgroundColor: "#D6D6D6",
//                   padding: "8px",
//                 }}
//               >
//                 QUESTION ID # {selectedQuestion.questionId}
//               </p>
//             </div>
//             <div
//               className="modal-question-options"
//               style={{
//                 maxHeight: "600px",
//                 overflowY: "auto",
//                 boxSizing: "border-box",
//               }}
//             >
//               <p style={{ fontSize: "18px" }}>
//                 Question Type: {selectedQuestion.questionType}
//               </p>
//               {selectedQuestion.options.length > 0 ? (
//                 <ul>
//                   <span style={{ fontSize: "18px", fontWeight: "bold" }}>
//                     Question:
//                   </span>
//                   <span style={{ fontSize: "25px", marginLeft: "3px" }}>
//                     {renderQuestionTextModel(selectedQuestion.questionText)}
//                   </span>
//                   {selectedQuestion.options.map((option, index) => (
//                     <li key={index} className="option-list-item">
//                       <div className="toggle-radio">
//                         <input
//                           type="radio"
//                           checked={option.option_correct_flag}
//                           readOnly
//                         />
//                         <div>{renderQuestionTextModel(option.option_text)}</div>
//                       </div>
//                     </li>
//                   ))}
//                 </ul>
//               ) : (
//                 <p>No options available for this question.</p>
//               )}
//               {selectedQuestion.tags.length > 0 && (
//                 <p
//                   style={{
//                     marginTop: "20px",
//                     fontSize: "18px",
//                     color: "#6A6A6A",
//                   }}
//                 >
//                   {selectedQuestion.tags
//                     .map((tag) => {
//                       if (tag.tag_type === 1) {
//                         return tag.tag_value;
//                       } else if (tag.tag_type === 2 && tag.tag_value != null) {
//                         return tag.tag_name;
//                       }
//                       return null;
//                     })
//                     .filter(Boolean)
//                     .join(", ")}
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>
//       )} */}
//         {isQuesModalVisible && selectedQuestion && (
//           <div
//             className="modal-overlay"
//             onClick={() => setIsQuesModalVisible(false)}
//             style={{ cursor: "default" }}
//           >
//             {/* outside close icon (plain X, no bg) */}
//             <button
//               className="modal-close-outside"
//               aria-label="Close"
//               onClick={(e) => { e.stopPropagation(); setIsQuesModalVisible(false); }}
//               style={{ lineHeight: "24px" }}
//             >
//               ×
//             </button>

//             <div
//               className="modal-content-all-question"
//               onClick={(e) => e.stopPropagation()}
//               style={{ backgroundClip: "padding-box" }}
//             >
//               {/* Header: keep inline font size, remove bg, add 1px border bottom */}
//               <div className="modal-header-del">
//                 <p
//                   style={{
//                     fontSize: "18px",
//                     color: "#424342",
//                     margin: 0,
//                     padding: "10px 14px",
//                     backgroundColor: "transparent",
//                     borderBottom: "1px solid #d6d6d6",
//                     userSelect: "none"
//                   }}
//                 >
//                   QUESTION ID - {selectedQuestion.questionId}
//                 </p>
//               </div>

//               <div
//                 className="modal-question-options"
//                 style={{
//                   maxHeight: "600px",
//                   overflowY: "auto",
//                   boxSizing: "border-box",
//                   color: "#424342",
//                   backgroundColor: "transparent",
//                   padding: "20px",
//                   WebkitOverflowScrolling: "touch"
//                 }}
//               >
//                 <p style={{ fontSize: "18px", marginTop: 0, color: "#424342" }}>
//                   Question Type: {selectedQuestion.questionType}
//                 </p>

//                 {selectedQuestion.options.length > 0 ? (
//                   <ul style={{ marginTop: 10, paddingLeft: 20 }}>
//                     <span style={{ fontSize: "18px", color: "#424342", display: "inline-block" }}>
//                       Question:
//                     </span>
//                     <span style={{ fontSize: "22px", marginLeft: "3px", color: "#424342", verticalAlign: "baseline" }}>
//                       {renderQuestionTextModel(selectedQuestion.questionText)}
//                     </span>

//                     {selectedQuestion.options.map((option, index) => (
//                       <li key={index} className="option-list-item" style={{ listStyle: "none", fontSize: "22px", marginTop: "15px", paddingBottom: "20px" }}>
//                         <label className="toggle-radio" style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "default" }}>
//                           <input type="radio" checked={option.option_correct_flag} readOnly />
//                           <div style={{ color: "#424342" }}>{renderQuestionTextModel(option.option_text)}</div>
//                         </label>
//                       </li>
//                     ))}
//                   </ul>
//                 ) : (
//                   <p style={{ color: "#6A6A6A", marginTop: 8 }}>No options available for this question.</p>
//                 )}

//                 {selectedQuestion.tags.length > 0 && (
//                   <p style={{ marginTop: "20px", fontSize: "18px", color: "#6A6A6A", wordBreak: "break-word" }}>
//                     {selectedQuestion.tags
//                       .map((tag) => {
//                         if (tag.tag_type === 1) return tag.tag_value;
//                         if (tag.tag_type === 2 && tag.tag_value != null) return tag.tag_name;
//                         return null;
//                       })
//                       .filter(Boolean)
//                       .join(", ")}
//                   </p>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}

//     </div>
//   );
// };

// const QuestionBank = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const navigate = useNavigate();
//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
//   const reviewType = "hod";
//   const reviewLevel = 1;
//   const pageId = "QuestionBank";
//   const page = 1;
//   const pageSize = 100;
//   const accessToken = localStorage.getItem("other");
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [expandedStates, setExpandedStates] = useState({});
//   const flagCountIndex = headers.indexOf("Flag Count");
//   const statusTextIndex = headers.indexOf("Status");
  
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     if (dataClient) {
//       fetchDashboardData();
//     }
//   }, [dataClient]);

//   const renderQuestionText = (questionText) => {
//     // const decodedQuestion = he.decode(questionText);
//     const decodedQuestion = he.decode(String(questionText || ""));

//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-3">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const toggleImage = (key) => {
//     setExpandedStates((prevStates) => ({
//       ...prevStates,
//       [key]: !prevStates[key], // Toggle based on the unique key
//     }));
//   };

//   const renderQuestionTextModel = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return (
//       <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
//         {questionSegments.map((segment, index) => {
//           if (segment.startsWith("imgsrc=")) {
//             const imageUrl = segment.replace("imgsrc=", "");
//             const key = `${questionText}-${index}`;
//             const isExpanded = expandedStates[key] || false;

//             return (
//               <img
//                 key={index}
//                 src={imageUrl}
//                 alt={`Question Image ${index}`}
//                 style={{
//                   width: "auto",
//                   height: "auto",
//                   maxWidth: isExpanded ? "450px" : "200px",
//                   maxHeight: isExpanded ? "550px" : "250px",
//                   objectFit: "contain",
//                   margin: "0 5px",
//                   verticalAlign: "middle",
//                   cursor: "pointer",
//                 }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   toggleImage(key);
//                 }}
//               />
//             );
//           } else {
//             return (
//               <span key={index} style={{ margin: "0 5px" }}>
//                 <Latex>{segment}</Latex>
//               </span>
//             );
//           }
//         })}
//       </div>
//     );
//   };

//   // const fetchDashboardData = async () => {
//   const [questionDetailsMap, setQuestionDetailsMap] = useState({}); // Store full question details

//   // const fetchDashboardData = async () => {
//   //   try {
//   //     const response = await fetch(
//   //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-ques-list-for-review/?client_id=${clientId}&client_branch_id=${clientBranchId}&username=${userName}&review_type=${reviewType}&review_level=${reviewLevel}&page_id=${pageId}`,
//   //       {
//   //         method: "GET",
//   //         headers: {
//   //           Authorization: `Bearer ${accessToken}`,
//   //           "Content-Type": "application/json",
//   //         },
//   //       }
//   //     );

//   //     if (!response.ok) {
//   //       throw new Error("Failed to fetch dashboard data.");
//   //     }

//   //     const result = await response.json();
//   //     const { data, status, message } = result;

//   //     if (status !== 200) {
//   //       throw new Error(message || "Failed to fetch dashboard data");
//   //     }

//   //     // Extract headers and rows from the `table_data`
//   //     const rawTableData = data?.table_data || [];
//   //     const rawHeaders = rawTableData[0] || [];
//   //     const rawRows = rawTableData.slice(1) || [];

//   //     const rawHeaderNames = rawHeaders.map((header) =>
//   //       header.replace(/^t\*|d\*|n\*/, "")
//   //     );
//   //     const setIdIndex = rawHeaderNames.indexOf("Set ID");

//   //     const filteredHeaders = rawHeaderNames.filter(
//   //       (header) => header !== "Set ID"
//   //     );

//   //     const transformedRows = rawRows.map((row) =>
//   //       row
//   //         .map((cell, index) => {
//   //           if (rawHeaders[index]?.startsWith("d*")) {
//   //             return new Date(cell).toLocaleDateString("en-US", {
//   //               year: "numeric",
//   //               month: "short",
//   //               day: "2-digit",
//   //             });
//   //           }
//   //           return cell;
//   //         })
//   //         .filter((_, idx) => idx !== setIdIndex)
//   //     );

//   //     // Store the full question data mapped by question ID
//   //     const questionDetails = {};
//   //     (data.result_list || []).forEach((question) => {
//   //       questionDetails[question.question_id] = {
//   //         questionId: question.question_id,
//   //         questionText: question.question_text,
//   //         questionType: question.ques_type,
//   //         options: question.options || [],
//   //         tags: question.tags || [],
//   //       };
//   //     });

//   //     setHeaders(filteredHeaders);
//   //     setReportDashboardData(transformedRows);
//   //     setQuestionDetailsMap(questionDetails);
//   //   } catch (error) {
//   //     console.error("Error fetching dashboard data:", error);
//   //   }
//   // };

// // Update your fetchDashboardData function to use the loading state:
  
//   const fetchDashboardData = async () => {
//       setIsLoading(true); // Start loading
//       try {
//         const response = await fetch(
//            `${EndPoints.PRISM_GET_QUES_LIST_FOR_REVIEW}?client_id=${clientId}&client_branch_id=${clientBranchId}&username=${userName}&page_id=${pageId}&page=${page}&page_size=${pageSize}`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Failed to fetch dashboard data.");
//         }

//         const result = await response.json();
//         const { data, status, message } = result;

//         if (status !== 200) {
//           throw new Error(message || "Failed to fetch dashboard data");
//         }

//         // ... rest of your existing data processing code ...
//         const rawTableData = data?.table_data || [];
//         const rawHeaders = rawTableData[0] || [];
//         const rawRows = rawTableData.slice(1) || [];

//         const rawHeaderNames = rawHeaders.map((header) =>
//           header.replace(/^t\*|d\*|n\*/, "")
//         );
//         const setIdIndex = rawHeaderNames.indexOf("Set ID");

//         const filteredHeaders = rawHeaderNames.filter(
//           (header) => header !== "Set ID"
//         );

//         const transformedRows = rawRows.map((row) =>
//           row
//             .map((cell, index) => {
//               if (rawHeaders[index]?.startsWith("d*")) {
//                 return new Date(cell).toLocaleDateString("en-US", {
//                   year: "numeric",
//                   month: "short",
//                   day: "2-digit",
//                 });
//               }
//               return cell;
//             })
//             .filter((_, idx) => idx !== setIdIndex)
//         );

//         const questionDetails = {};
//         (data.result_list || []).forEach((question) => {
//           questionDetails[question.question_id] = {
//             questionId: question.question_id,
//             questionText: question.question_text,
//             questionType: question.ques_type,
//             options: question.options || [],
//             tags: question.tags || [],
//           };
//         });

//         setHeaders(filteredHeaders);
//         setReportDashboardData(transformedRows);
//         setQuestionDetailsMap(questionDetails);
//       } catch (error) {
//         console.error("Error fetching dashboard data:", error);
//       } finally {
//         setIsLoading(false); // Stop loading regardless of success or failure
//       }
//   };

//   const handleMarkSpecialClick = () => {
//     if (selectedRows.length === 0) {
//       setMessageBox("No questions selected!");
//       setIsMessageBoxVisible(true);
//       return;
//     }

//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>
//             Click on Proceed to mark selected question(s) as Special
//             question(s).
//           </span>
//         </div>
//         <div
//           className="messagebox-insider2"
//           style={{ display: "flex", gap: "10px" }}
//         >
//           <button
//             className="messagebox-cancel-btn-ok"
//             style={{ width: "72px" }}
//             onClick={() => confirmUpdateStatus(selectedRows, 13)} // Status 13 for Mark Special
//           >
//             Proceed
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             style={{ width: "62px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//   };

//   const handleEyeClick = (questionId) => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>
//             Do you want to change the status of this Special question to
//             general?
//           </span>
//         </div>
//         <div
//           className="messagebox-insider2"
//           style={{ display: "flex", gap: "10px" }}
//         >
//           <button
//             className="messagebox-cancel-btn-ok"
//             style={{ width: "72px" }}
//             onClick={() => confirmUpdateStatus(questionId, 8)} // Status 8 for General
//           >
//             Proceed
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             style={{ width: "62px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//   };

//   const confirmUpdateStatus = async (questionIds, newStatus) => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Updating the question status, please wait...</span>
//         </div>
//       </div>
//     );

//     const payload = {
//       question_ids: Array.isArray(questionIds) ? questionIds : [questionIds], // Ensure it's always an array
//       status: newStatus, // Either 8 (general) or 13 (special)
//       user_name: userName,
//     };

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-ques-status/`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const result = await response.json();

//       if (response.ok) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               {newStatus === 13
//                 ? "Successfully marked the selected question(s) as Special."
//                 : "Successfully updated the question status to General."}
//             </div>
//           </div>
//         );
//         setActiveImg(InfoImg);
//         fetchDashboardData();
//         setSelectedRows([]);
//       } else {
//         throw new Error(result.message || "Failed to update status.");
//       }
//     } catch (error) {
//       console.error("Error updating question status:", error);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             {/* <span>Failed to update status. Please try again later.</span> */}
//             <span>The question is marked special already.</span>
//           </div>
//         </div>
//       );
//     } finally {
//       setTimeout(() => setIsMessageBoxVisible(true));
//     }
//   };

//   const handleCancel = () => {
//     window.location.reload(); // This will refresh the page
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "20px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
//         <div className="create-role-container-ques-dashboards">
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             Question Bank Dashboard
//           </p>
//           <div style={{ display: "flex" }}>
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//               }}
//               onClick={handleCancel} // Add onClick handler
//             >
//               CANCEL
//             </button>
//             {/* <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 width: "160px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
//                 cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
//                 color: selectedRows.length > 0 ? "#424342" : "",
//               }}
//               onClick={handleMarkSpecialClick}
//               disabled={selectedRows.length === 0}
//               onMouseEnter={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "#fa4741";
//                   e.target.style.color = "white";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#424342";
//                 }
//               }}
//             >
//               MARK SPECIAL
//             </button> */}
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 width: "160px",
//                 backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
//                 cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
//                 color: selectedRows.length > 0 ? "#424342" : "",
//               }}
//               onMouseEnter={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "#fa4741";
//                   e.target.style.color = "white";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#424342";
//                 }
//               }}
//               onClick={() => {
//                 if (selectedRows.length > 0) {
//                   const queryString = selectedRows.join(","); // Join selected IDs with commas
//                   navigate(
//                     `/question_bank_review?MNTQuestionNumbers=${queryString}`
//                   ); // Pass IDs in the query string
//                 }
//               }}
//             >
//               VIEW SELECTED
//             </button>
//           </div>
//         </div>
//         <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//           View, create, or filter Questions. Export a list of question or search
//           for a question. When searching, enter at least two characters in the
//           search field.
//         </p>
//         <div>
//           <TableComponent
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Questions..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//             renderQuestionText={renderQuestionText}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             renderQuestionTextModel={renderQuestionTextModel}
//             expandedStates={expandedStates}
//             toggleImage={toggleImage}
//             questionDetailsMap={questionDetailsMap}
//             handleEyeClick={handleEyeClick}
//             isLoading={isLoading} 
//           />
//           {/* <TablewithCheckbox
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Questions..."
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             renderQuestionText={renderQuestionText}
//             renderQuestionTextModel={renderQuestionTextModel}
//             expandedStates={expandedStates}
//             toggleImage={toggleImage}
//             questionDetailsMap={questionDetailsMap}
//             handleEyeClick={handleEyeClick}
//             pageType="questionbank"
//           /> */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QuestionBank;









import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import InfoImg from "./../../../Assets/Images/CommanImages/Informative.png";
import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
import FlagIcon from "./../../../Assets/Images/CommanImages/flag_icon.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { API_BASE_URL } from "../../../Config/Config";
import "../QuestionDashboard/questiondashborad.css";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
import "./quesbank.css";
import TablewithCheckbox from "../../../Components/TableComponent/TablewithCheckbox";
import EndPoints from "../../../Api/Endpoints";
import QuesBankTableComponent from "./QuesBankTableComponent";


const QuestionBank = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();

  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

  const reviewType = "hod";
  const reviewLevel = 1;
  const pageId = "QuestionBank";

  const accessToken = localStorage.getItem("other");

  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [expandedStates, setExpandedStates] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [questionDetailsMap, setQuestionDetailsMap] = useState({});

  // ── Server-side pagination state ──
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalCount, setTotalCount] = useState(0);

  const flagCountIndex = headers.indexOf("Flag Count");
  const statusTextIndex = headers.indexOf("Status");

  // Re-fetch whenever page or pageSize changes
  useEffect(() => {
    if (dataClient) {
      fetchDashboardData(currentPage, pageSize);
    }
  }, [dataClient, currentPage, pageSize]);

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(String(questionText || ""));
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-3">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const toggleImage = (key) => {
    setExpandedStates((prevStates) => ({
      ...prevStates,
      [key]: !prevStates[key],
    }));
  };

  const renderQuestionTextModel = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return (
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        {questionSegments.map((segment, index) => {
          if (segment.startsWith("imgsrc=")) {
            const imageUrl = segment.replace("imgsrc=", "");
            const key = `${questionText}-${index}`;
            const isExpanded = expandedStates[key] || false;
            return (
              <img
                key={index}
                src={imageUrl}
                alt={`Question Image ${index}`}
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: isExpanded ? "450px" : "200px",
                  maxHeight: isExpanded ? "550px" : "250px",
                  objectFit: "contain",
                  margin: "0 5px",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleImage(key);
                }}
              />
            );
          } else {
            return (
              <span key={index} style={{ margin: "0 5px" }}>
                <Latex>{segment}</Latex>
              </span>
            );
          }
        })}
      </div>
    );
  };

  const fetchDashboardData = async (page = 1, size = 10) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${EndPoints.PRISM_GET_QUES_LIST_FOR_REVIEW}?client_id=${clientId}&client_branch_id=${clientBranchId}&username=${userName}&page_id=${pageId}&page=${page}&page_size=${size}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch dashboard data.");
      }

      const result = await response.json();
      const { data, status, message } = result;

      if (status !== 200) {
        throw new Error(message || "Failed to fetch dashboard data");
      }

      const rawTableData = data?.table_data || [];
      const rawHeaders = rawTableData[0] || [];
      const rawRows = rawTableData.slice(1) || [];

      const rawHeaderNames = rawHeaders.map((header) =>
        header.replace(/^t\*|d\*|n\*/, "")
      );
      const setIdIndex = rawHeaderNames.indexOf("Set ID");

      const filteredHeaders = rawHeaderNames.filter(
        (header) => header !== "Set ID"
      );

      const transformedRows = rawRows.map((row) =>
        row
          .map((cell, index) => {
            if (rawHeaders[index]?.startsWith("d*")) {
              return new Date(cell).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "2-digit",
              });
            }
            return cell;
          })
          .filter((_, idx) => idx !== setIdIndex)
      );

      const questionDetails = {};
      (data.result_list || []).forEach((question) => {
        questionDetails[question.question_id] = {
          questionId: question.question_id,
          questionText: question.question_text,
          questionType: question.ques_type,
          options: question.options || [],
          tags: question.tags || [],
        };
      });
      setTotalCount(data.total_count || 0);
      setHeaders(filteredHeaders);
      setReportDashboardData(transformedRows);
      setQuestionDetailsMap(questionDetails);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    window.location.reload();
  };

  return (
    <div style={{ height: "auto", width: "100%", paddingLeft: "20px", marginBottom: "40px" }}>
      <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
        <div className="create-role-container-ques-dashboards">
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>Question Bank Dashboard</p>
          <div style={{ display: "flex" }}>
            <button
              className="create-test-section-btn"
              style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }}
              onClick={handleCancel}
            >
              CANCEL
            </button>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
                width: "160px",
                backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
                cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
                color: selectedRows.length > 0 ? "#424342" : "",
              }}
              onMouseEnter={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "#fa4741";
                  e.target.style.color = "white";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#424342";
                }
              }}
              onClick={() => {
                if (selectedRows.length > 0) {
                  const queryString = selectedRows.join(",");
                  navigate(`/question_bank_review?MNTQuestionNumbers=${queryString}`);
                }
              }}
            >
              VIEW SELECTED
            </button>
          </div>
        </div>

        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View, create, or filter Questions. Export a list of question or search for a question.
          When searching, enter at least two characters in the search field.
        </p>

        <div>
          <QuesBankTableComponent
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Questions..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            renderQuestionText={renderQuestionText}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            renderQuestionTextModel={renderQuestionTextModel}
            expandedStates={expandedStates}
            toggleImage={toggleImage}
            questionDetailsMap={questionDetailsMap}
            // handleEyeClick={handleEyeClick}
            isLoading={isLoading}
            // ── Pass server-side pagination props ──
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            totalCount={totalCount}
          />
        </div>
      </div>
    </div>
  );
};

export default QuestionBank;












  // const handleMarkSpecialClick = () => {
  //   if (selectedRows.length === 0) {
  //     setMessageBox("No questions selected!");
  //     setIsMessageBoxVisible(true);
  //     return;
  //   }
  //   setIsMessageBoxVisible(true);
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <span>Click on Proceed to mark selected question(s) as Special question(s).</span>
  //       </div>
  //       <div className="messagebox-insider2" style={{ display: "flex", gap: "10px" }}>
  //         <button
  //           className="messagebox-cancel-btn-ok"
  //           style={{ width: "72px" }}
  //           onClick={() => confirmUpdateStatus(selectedRows, 13)}
  //         >
  //           Proceed
  //         </button>
  //         <button
  //           className="messagebox-cancel-btn-ok"
  //           style={{ width: "62px" }}
  //           onClick={() => setIsMessageBoxVisible(false)}
  //         >
  //           Cancel
  //         </button>
  //       </div>
  //     </div>
  //   );
  //   setActiveImg(InterogativeImg);
  // };

  // const handleEyeClick = (questionId) => {
  //   setIsMessageBoxVisible(true);
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <span>Do you want to change the status of this Special question to general?</span>
  //       </div>
  //       <div className="messagebox-insider2" style={{ display: "flex", gap: "10px" }}>
  //         <button
  //           className="messagebox-cancel-btn-ok"
  //           style={{ width: "72px" }}
  //           onClick={() => confirmUpdateStatus(questionId, 8)}
  //         >
  //           Proceed
  //         </button>
  //         <button
  //           className="messagebox-cancel-btn-ok"
  //           style={{ width: "62px" }}
  //           onClick={() => setIsMessageBoxVisible(false)}
  //         >
  //           Cancel
  //         </button>
  //       </div>
  //     </div>
  //   );
  //   setActiveImg(InterogativeImg);
  // };

  // const confirmUpdateStatus = async (questionIds, newStatus) => {
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span>Updating the question status, please wait...</span>
  //       </div>
  //     </div>
  //   );

  //   const payload = {
  //     question_ids: Array.isArray(questionIds) ? questionIds : [questionIds],
  //     status: newStatus,
  //     user_name: userName,
  //   };

  //   try {
  //     const response = await fetch(
  //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-ques-status/`,
  //       {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     const result = await response.json();

  //     if (response.ok) {
  //       setIsMessageBoxVisible(true);
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             {newStatus === 13
  //               ? "Successfully marked the selected question(s) as Special."
  //               : "Successfully updated the question status to General."}
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(InfoImg);
  //       fetchDashboardData(currentPage, pageSize);
  //       setSelectedRows([]);
  //     } else {
  //       throw new Error(result.message || "Failed to update status.");
  //     }
  //   } catch (error) {
  //     console.error("Error updating question status:", error);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <span>The question is marked special already.</span>
  //         </div>
  //       </div>
  //     );
  //   } finally {
  //     setTimeout(() => setIsMessageBoxVisible(true));
  //   }
  // };
